<kilowant-header [showAccountList]="false" [isBuyer]="true" title="Settings"></kilowant-header>
<div class="wrapperMain mainAccountDetailsMain accountDetails">
    <div class="form buyer">
        <mat-tab-group mat-align-tabs="start" #tabs>
            <mat-tab>
                <ng-template mat-tab-label>
                    Contact
                </ng-template>
                <div class="card" *ngIf="inEditMode!=1">
                    <div class="body">
                        <p class="accountInfoBorder">First Name</p>
                        <p class="subUniqueTitle">{{user.firstName}}</p>
                        <p class="accountInfoBorder">Last Name</p>
                        <p class="subUniqueTitle">{{user.lastName}}</p>
                        @if(user.company!=null)
                        {
                        <p class="accountInfoBorder">Company</p>
                        <p class="subUniqueTitle">{{user.company.name}}</p>
                        }
                        <p class="accountInfoBorder">Primary Mailing Address</p>
                        <p class="subUniqueTitle">{{(user.addressLine1!=null && user.addressLine1.length>0)?user.addressLine1:'-'}}</p>
                        <p class="accountInfoBorder">Address Line 2</p>
                        <p class="subUniqueTitle">{{(user.addressLine2!=null && user.addressLine2.length>0)?user.addressLine2:'-'}}</p>
                        <p class="accountInfoBorder">State</p>
                        <p class="subUniqueTitle">{{(user.state!=null)?user.state.name:'-'}}</p>
                        <p class="accountInfoBorder">City</p>
                        <p class="subUniqueTitle">{{(user.city!=null && user.city.length>0)?user.city:'-'}}</p>
                        <p class="accountInfoBorder">Zip</p>
                        <p class="subUniqueTitle">{{(user.zip!=null && user.zip.length>0)?user.zip:'-'}}</p>

                        @if(user.company!=null && user.company.taxExempt)
                        {
                        <p class="accountInfoBorder">Is Tax Exempt</p>
                        <p class="subUniqueTitle">Yes</p>
                        <p class="accountInfoBorder">Federal Tax ID</p>
                        <p class="subUniqueTitle">{{user.company.federalTaxID}}</p>
                        <p class="accountInfoBorder">Tax exempt certificate</p>
                        <p class="subUniqueTitle" *ngIf="user!.company!.taxExemptCertificateDocument!=null">
                            <span class="link" (click)="downloadFile(true, user!.company!.taxExemptCertificateDocument.key)">{{user!.company!.taxExemptCertificateDocument.value}}</span>
                        </p>
                        }

                        <p class="accountInfoBorder">Mobile Phone</p>
                        <p class="subUniqueTitle">{{(user.phone!=null && user.phone.length>0)?user.phone:'-'}}</p>
                        <p class="accountInfoBorder">Email</p>
                        <p class="subUniqueTitle">{{user.email}}</p>
                        <div class="block-buttons full-width small mt-20">
                            <button type="button" (click)="editMode(1)">Edit</button>
                        </div>
                    </div>
                </div>
                <div class="card" *ngIf="inEditMode==1">
                    <div class="body">
                        <input type="text" name="firstName" class="w-100"
                               [class]="getClassesForInput('firstName', true, user.firstName)" value="" (input)="resetError('firstName')"
                               [(ngModel)]="user.firstName" placeholder="First Name" />
                        <div class="placeholder" *ngIf="getVisibilityForLabel(user.firstName)">First name</div>
                        <input type="text" name="lastName" class="w-100"
                               [class]="getClassesForInput('lastName', true, user.lastName)" value="" (input)="resetError('lastName')"
                               [(ngModel)]="user.lastName" placeholder="Last Name" />
                        <div class="placeholder" *ngIf="getVisibilityForLabel(user.lastName)">Last name</div>

                        @if(user.company!=null)
                        {
                        <input type="text" name="company" class="w-100"
                               [class]="getClassesForInput('company', true, user.company.name)" value="" (input)="resetError('company')"
                               [(ngModel)]="user.company.name" placeholder="Company" />
                        <div class="placeholder" *ngIf="getVisibilityForLabel(user.company.name)">Company</div>
                        }

                        <input type="text"
                               name="addressLine1"
                               [class]="getClassesForInput('addressLine1', true, user.addressLine1)"
                               (input)="resetError('addressLine1')"
                               placeholder="Primary Mailing Address"
                               [(ngModel)]="user.addressLine1"
                               [minlength]="validationService.getMinLength('User', 'address')"
                               [maxlength]="validationService.getMaxLength('User', 'address')" />
                        <div class="placeholder" *ngIf="getVisibilityForLabel(user.addressLine1)">Primary Mailing Address</div>
                        <input type="text"
                               name="addressLine2"
                               [class]="getClassesForInput('addressLine2', true, user.addressLine2)"
                               (input)="resetError('addressLine2')"
                               placeholder="Address Line 2"
                               [(ngModel)]="user.addressLine2"
                               [minlength]="0"
                               [maxlength]="validationService.getMaxLength('User', 'address')" />
                        <div class="placeholder" *ngIf="getVisibilityForLabel(user.addressLine2)">Address Line 2</div>

                        <div class="cols">
                            <div class="col">
                                <select [class]="getClassesForInput('city', true, user.city)"
                                        name="city"
                                        (change)="resetError('city');"
                                        [(ngModel)]="user.city">
                                    <option [ngValue]="null" [disabled]="true" *ngIf="user.city==null">City</option>
                                    <option *ngFor="let city of cities" [ngValue]="city">{{city}}</option>
                                </select>
                                <div class="placeholder" *ngIf="getVisibilityForLabel(user.city)">City</div>
                            </div>
                            <div class="col">
                                <select [class]="getClassesForInput('stateId', true, 'ST')"
                                        [compareWith]="compareFn"
                                        name="stateId"
                                        style="width: 60px !important;"
                                        (change)="resetError('stateId'); filterCities();"
                                        [(ngModel)]="user.state">
                                    <option [ngValue]="null" [disabled]="true" *ngIf="user.state==null">ST</option>
                                    <option *ngFor="let state of states" [ngValue]="state">{{state.stateCode}}</option>
                                </select>
                                <div class="placeholder" *ngIf="getVisibilityForLabel((user.state==null)?null:user.state.name)">State</div>
                            </div>
                            <div class="col">
                                <input type="text"
                                       name="address"
                                       [class]="getClassesForInput('zip', true, user.zip)"
                                       (input)="resetError('zip')"
                                       placeholder="Zip"
                                       [(ngModel)]="user.zip"
                                       [minlength]="validationService.getMinLength('User', 'zip')"
                                       [maxlength]="validationService.getMaxLength('User', 'zip')" />
                                <div class="placeholder" *ngIf="getVisibilityForLabel(user.zip)">Zip</div>
                            </div>
                        </div>

                        <input type="text" name="Phone"
                               [class]="getClassesForInput('Phone', true, (((currentPhoneNumber.value==null)?'':currentPhoneNumber.value?.trim())+(focusedField()=='Phone')?'1':''))"
                               (input)="resetError('Phone')"
                               placeholder="Mobile Phone"
                               [dropSpecialCharacters]="false"
                               [formControl]="currentPhoneNumber"
                               (focus)="focusField('Phone')"
                               mask="(000) 000-0000"
                               [showMaskTyped]="(focusedField()=='Phone')||(currentPhoneNumber.value!=null && currentPhoneNumber.value?.trim()!='' && !currentPhoneNumber.value.valid)" />
                        <div class="placeholder" *ngIf="getVisibilityForLabel(((currentPhoneNumber.value==null)?'':currentPhoneNumber.value?.trim())+((focusedField()=='Phone')?'phone':''))">Mobile Phone</div>

                        @if (user.company!=null) {
                        <div>
                            <div class="mb-10 mt-10">
                                <label>
                                    <input type="checkbox" name="taxExempt" [(ngModel)]="user.company.taxExempt" /> Is your business
                                    tax exempt?
                                </label>
                            </div>
                            @if (user.company.taxExempt) {
                            <div>
                                <input type="text" name="FederalTaxID" class="w-100"
                                       [class]="getClassesForInput('FederalTaxID', true, user.company.federalTaxID)" value=""
                                       (input)="resetError('FederalTaxID')" [(ngModel)]="user.company.federalTaxID"
                                       placeholder="Federal Tax ID" />
                                @if (getVisibilityForLabel(user.company.federalTaxID)) {
                                <div class="placeholder">Federal Tax ID</div>
                                }
                                <div class="mt-20"> Please upload a photo or a copy of your tax exempt certificate.</div>
                                @if ((fileToUpload==null) && user.company.taxExemptCertificateDocument==null) {
                                <label class="formLabel"
                                       [class]="(errorY().isWrong('fileToUpload'))?'error':''">
                                    CHOOSE FILES
                                    <span>no files selected</span>
                                    <input type="file" name="taxExemptCertificateDocument" class="required" value=""
                                           placeholder="Tax Exempt Certificate Document" (change)="handleFileInput($event)" />
                                </label>
                                }
                                @if (fileToUpload!=null || user.company.taxExemptCertificateDocument!=null) {
                                <div class="files-list">
                                    <span>File selected</span>
                                    <ul>
                                        @if (user.company.taxExemptCertificateDocument!=null) {
                                        <li>
                                            <a (click)="deleteExistingFile()"></a>
                                            <div class="link" (click)="downloadFile(true, user.company.taxExemptCertificateDocument.key)">{{user.company.taxExemptCertificateDocument.value}}</div>
                                        </li>
                                        }
                                        @if (fileToUpload!=null) {
                                        <li>
                                            <a (click)="deleteFile()"></a>
                                            <div class="link" (click)="downloadFile(false, null)">{{fileToUpload.name}}</div>
                                        </li>
                                        }
                                    </ul>
                                </div>
                                }
                            </div>
                            }
                        </div>
                        }

                        <input type="text" name="email" class="w-100" [class]="getClassesForInput('email', true, user.email)"
                               value="" (input)="resetError('email')" [(ngModel)]="user.email" disabled />
                        <div class="placeholder" *ngIf="getVisibilityForLabel(user.email)">Email</div>

                        <div *ngIf="inEditMode==1" class="mt-20">
                            <div class="error-block" *ngIf="this.errorY().showError()">{{errorY().error}}</div>
                            <div class="block-buttons full-width small mt-20">
                                <button type="button" (click)="editMode(0)">Cancel</button>
                                <button type="button" (click)="sendForm()">Update</button>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    Password
                </ng-template>
                <div class="card">
                    <div class="body" *ngIf="inEditMode!=2">
                        <div class="block-buttons full-width small mt-20">
                            <button type="button" (click)="editMode(2)">Edit</button>
                        </div>
                    </div>
                    <div class="body" *ngIf="inEditMode==2">
                        <input type="password" class="w-100" name="OldPassword"
                               [class]="getClassesForInput('OldPassword', true, old_password)"
                               [type]="oldPasswordType" (input)="resetError('OldPassword')" [(ngModel)]="old_password"
                               placeholder="Old Password" />
                        <div class="password-holder" (click)="showPassword('oldPasswordType')">
                            <i [class]="(oldPasswordType=='password')?'password-show':'password-hide'"></i>
                        </div>
                        <div class="placeholder" *ngIf="getVisibilityForLabel(old_password)">Old Password</div>

                        <input type="password" class="w-100" name="Password"
                               [class]="getClassesForInput('Password', true, password)"
                               [type]="passwordType" (input)="resetError('Password')" [(ngModel)]="password" placeholder="Password" />

                        <div class="password-holder" (click)="showPassword('passwordType')">
                            <i [class]="(passwordType=='password')?'password-show':'password-hide'"></i>
                        </div>
                        <div class="placeholder" *ngIf="getVisibilityForLabel(password)">Password</div>

                        <input type="password" class="w-100" name="Password2"
                               [class]="getClassesForInput('Password2', true, password2)"
                               [type]="password2Type" (input)="resetError('Password2')" [(ngModel)]="password2"
                               placeholder="Password (confirm)" />
                        <div class="password-holder" (click)="showPassword('password2Type')">
                            <i [class]="(password2Type =='password')?'password-show':'password-hide'"></i>
                        </div>
                        <div class="placeholder" *ngIf="getVisibilityForLabel(password2)">Password (confirm)</div>

                        <div class="error-block" *ngIf="this.errorY().showError()">{{errorY().error}}</div>
                        <div class="block-buttons full-width small mt-20">
                            <button type="button" (click)="editMode(0)">Cancel</button>
                            <button type="button" (click)="sendUpdatePasswordForm()">Update</button>
                        </div>
                    </div>
                </div>
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    Alerts
                </ng-template>
                <div class="card">
                    <div class="body removelable">
                        <div class="account-info-block" *ngFor="let alertInfo of alertsData; let i = index">
                            <p class="card-block-background" [class]="(viewAlertsCategory[i])?'':'view-closed'">
                                {{alertInfo.key.name}}
                                <a [class]="(viewAlertsCategory[i])?'collapse':'open'"
                                   (click)="viewAlertsCategory[i] = !viewAlertsCategory[i]"></a>
                            </p>
                            <ng-container>
                                <div [class]="(viewAlertsCategory[i])?'visible':'hidden'">
                                    <div class="p-20" *ngIf="alertInfo.value==null || alertInfo.value.length==0">Coming Soon</div>
                                    <div class="alertbuttonpadding" *ngFor="let alert of alertInfo.value;">
                                        <div class="d-flex justify-content-between">
                                            <p class="pl-0 accountInfoBorder font16">{{alert.key.name}}</p>
                                            <label class="alertSwitch">
                                                <input type="checkbox" [checked]="positionsInSelected(alert.key).length>0" (click)="addRemoveAlertsMultiple(alert.key, alert.value)" id="{{alert.key.id}}_{{alert.value.id}}" />
                                                <span class="alertSwitchslider alertSwitchround"></span>
                                            </label>
                                        </div>
                                        <div class="pl-2" *ngIf="alert.value.length>0 && positionsInSelected(alert.key).length>0">
                                            <div *ngFor="let alertOption of alert.value;">
                                                <label>
                                                    <input [type]="(alert.key.multiOption)?'checkbox':'radio'" [name]="'o_'+alert.key.id" [checked]="positionInSelected(alert.key, alertOption)>-1" (click)="addRemoveAlert(alert.key, alertOption)" value="{{alertOption.id}}">
                                                    &nbsp; {{alertOption.name}}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                        <div class="block-buttons full-width small mt-20">
                            <button type="button" (click)="setAlerts()">Update</button>
                        </div>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>